import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./SpinnerOverlay.scss');
class SpinnerOverlay extends React.Component<{}, {}> {
    render() {
        return <Spinner className={styles.linkSpinner} size={SpinnerSize.xSmall} />;
    }
}

export function displaySpinnerOverlay(spinnerContainer: HTMLElement) {
    ReactDOM.render(<SpinnerOverlay />, spinnerContainer);
}
